export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      screenConfigMst: {
        screenConfigMstId: 1,
        screenConfigMstUuid: "screenconfigmst001",
        screenConfigName: "コミュニティサポート系トップ画面",
        deviceTypeName: "normal",
        serviceTypeName: "サービス名",
        screenOrientationKbn: 1,
        screenConifgStatus: 1,
        screenLayout: {
          layoutHeader: [
            {
              uuid: "layoutHeader_1000000001_1",
              type: "header",
              logoImageUseFlg: true,
              lightOffBtnUseFlg: 0,
              btnCount: 3,
              btnLayoutType: 1,
              roundCornerFlg: 0,
              rectRoundCornerStyle: {
                roundCornerLeftTop: 0,
                roundCornerRightTop: 0,
                roundCornerLeftBottom: 0,
                roundCornerRightBottom: 0
              },
              zIndex: 0
            }
          ],
          layoutFortune: [
            {
              uuid: "layoutFortune_1000000001_1",
              type: "fortune",
              posX: 0,
              posY: "200",
              layoutSizeType: 0,
              zIndex: 1
            }
          ],
          layoutButton: [
            {
              uuid: "layoutButton_1000000001_1",
              type: "button",
              posX: "300",
              posY: "200",
              width: 0,
              height: 0,
              btnLayoutType: 1,
              margin: null,
              btnLabelFontSize: null,
              btnLabelCharCountUpperLimit: null,
              labelAlignment: 1,
              roundCornerFlg: 1,
              rectRoundCornerStyle: {
                roundCornerLeftTop: 0,
                roundCornerRightTop: 0,
                roundCornerLeftBottom: 0,
                roundCornerRightBottom: 0
              },
              zIndex: 2
            }
          ],
          layoutLabel: [
            {
              uuid: "layoutLabel_1000000001_1",
              type: "label",
              posX: "550",
              posY: "200",
              width: 0,
              height: 0,
              textAlignment: 1,
              fontSize: null,
              charCountUpperLimit: null,
              zIndex: 3
            },
            {
              uuid: "layoutLabel_1000000001_2",
              type: "label",
              posX: "550",
              posY: "400",
              width: "150",
              height: "600",
              textAlignment: 1,
              fontSize: null,
              charCountUpperLimit: null,
              zIndex: 6
            }
          ],
          layoutPanel: [
            {
              uuid: "layoutPanel_1000000001_1",
              type: "panel",
              posX: "750",
              posY: "200",
              width: 0,
              height: 0,
              roundCornerFlg: 0,
              rectRoundCornerStyle: {
                roundCornerLeftTop: 0,
                roundCornerRightTop: 0,
                roundCornerLeftBottom: 0,
                roundCornerRightBottom: 0
              },
              zIndex: 4
            }
          ],
          layoutCalendar: [
            {
              uuid: "layoutCalendar_1000000001_1",
              type: "calender",
              posX: 0,
              posY: "400",
              zIndex: 5
            }
          ]
        }
      }
    }
  }
}